var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":'Select Room'},model:{value:(_vm.select_rooms),callback:function ($$v) {_vm.select_rooms=$$v},expression:"select_rooms"}},_vm._l((_vm.rooms),function(item){return _c('el-option',{key:item,attrs:{"label":item + (item > 1 ? ` ${_vm.$t('lbl_rooms')}` : ` ${_vm.$t('lbl_room')}`),"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }